import { client, getUrl } from "utils";

export const getSQSQueuesRequest = () => client.get(getUrl("sqs-queues"));
